module.exports = __webpack_public_path__ + "static/media/ba.268bd8aa.svg";